import { useEffect, useState } from "react";
import { container } from "tsyringe";
import UpcomingActionResponseResource from "common/resources/Project/Config/UpcomingAction/UpcomingActionResponseResource";
import { useProjectId } from "hooks/useProjectId";
import UpcomingActionService from "services/projects/UpcomingActionService";
import ActionCard from "./ActionCard";
import classes from "./classes.module.scss";

const upcomingActionService = container.resolve(UpcomingActionService);

export default function Actions() {
	const { projectId } = useProjectId();
	const { upcomingActions } = useActions(projectId);

	return (
		<div className={classes["root"]}>
			{upcomingActions.map((upcomingAction) => (
				<ActionCard action={upcomingAction} key={upcomingAction.id}  />
			))}
		</div>
	);
}

const useActions = (projectId: string) => {
	const [upcomingActions, setUpcomingActions] = useState<UpcomingActionResponseResource[]>([]);

	useEffect(() => {
		upcomingActionService.getAllByProjectId(projectId).then(setUpcomingActions);
	}, [projectId]);

	return { upcomingActions };
};
